/* eslint-disable react/prop-types */ // TODO: add props
import { EXAM_QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';
import {
  NumberOnImageQuestion,
  FillInBlankQuestion,
  NumberQuestion,
  IllustrationQuestion,
  ShortAnswerChecklistQuestion,
  ShortAnswerQuestion,
  SimpleMathQuestion,
  WorkedChecklistQuestion,
  WorkedQuestion,
  DragAndDropQuestion,
  SingleSelectQuestion,
  MultiSelectQuestion,
  ComplexSolutionQuestion,
  UnsupportedQuestionType,
} from './components';
import { QuestionInstructions, QuestionMetadata } from '..';
import styles from './styles.scss';
import { useAnalytics } from 'edrolo/analytics';

const getQuestionTypeComponent = (question) => {
  const questionType = question.get('question_type');

  switch (questionType) {
    case EXAM_QUESTION_TYPES.SINGLE_ANSWER_MULTI_CHOICE:
      return SingleSelectQuestion;

    case EXAM_QUESTION_TYPES.TEXT_CHECKLIST:
      return ShortAnswerChecklistQuestion;

    case EXAM_QUESTION_TYPES.WORKED:
      return WorkedQuestion;

    case EXAM_QUESTION_TYPES.WORKED_ANNOTATED_IMAGE:
      return WorkedChecklistQuestion;

    case EXAM_QUESTION_TYPES.SIMPLE_MATH:
      return SimpleMathQuestion;

    case EXAM_QUESTION_TYPES.NUMBER:
      return NumberQuestion;

    case EXAM_QUESTION_TYPES.NUMBER_ON_IMAGE:
      return NumberOnImageQuestion;

    case EXAM_QUESTION_TYPES.FILL_IN_BLANK:
      return FillInBlankQuestion;

    case EXAM_QUESTION_TYPES.ILLUSTRATION:
      return IllustrationQuestion;

    case EXAM_QUESTION_TYPES.DRAG_AND_DROP:
      return DragAndDropQuestion;

    case EXAM_QUESTION_TYPES.SELECT_MULTI:
      return MultiSelectQuestion;

    case EXAM_QUESTION_TYPES.TEXT:
      return ShortAnswerQuestion;

    case EXAM_QUESTION_TYPES.COMPLEX:
      return ComplexSolutionQuestion;

    default:
      return UnsupportedQuestionType;
  }
};

export const Question = ({
  question,
  response,
  onSubmit,
  onSubmitChecklistReflectionItem,
  onSubmitGrok,
  onSubmitMark,
  isTeacher,
  showIncompleteChecklistWarning,
  shouldDisableRespondingToThisQuestion = false,
}) => {
  const marks = +question.get('marks');
  const spicinessLevel = question.get('spiciness_level');
  const workingPathways = question.get('working_pathways')?.toArray();
  const skill = isTeacher && question.get('skill')?.toJS();

  const { addEventAttributes, track } = useAnalytics({});
  addEventAttributes({ question_id: question.get('id') });

  const QuestionTypeComponent = getQuestionTypeComponent(question);

  return (
    <div className={styles.question}>
      <div className={styles.questionMetadata} data-test="questionListMetadata">
        <QuestionMetadata
          marks={marks}
          spicinessLevel={spicinessLevel}
          workingPathways={workingPathways}
          skill={skill}
        />
      </div>
      <QuestionInstructions question={question} />
      <QuestionTypeComponent
        key={question.get('id')}
        question={question}
        response={response}
        onSubmit={(typeSpecificData) => {
          onSubmit(typeSpecificData);
          track('submitted lesson question response');
        }}
        onSubmitChecklistReflectionItem={(reflection) => {
          onSubmitChecklistReflectionItem(reflection);
          track('submitted checklist reflection');
        }}
        onSubmitGrok={(grok) => {
          onSubmitGrok(grok);
          track('submitted lesson question grokked');
        }}
        onSubmitMark={(mark) => {
          onSubmitMark(mark);
          track('question self marked');
        }}
        showIncompleteChecklistWarning={showIncompleteChecklistWarning}
        shouldDisableRespondingToThisQuestion={
          shouldDisableRespondingToThisQuestion
        }
      />
    </div>
  );
};
